import * as React from "react";
import { forwardRef } from "react";
const SvgRelationGrouped = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 29 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M8.00002 8.49995H5.00002L5 6.49996H8L8.00002 8.49995Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.00002 8.49995H1.71661e-05L0 6.49996H3L3.00002 8.49995Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13 8.49995H10L10 6.49996H13L13 8.49995Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18 8.49995H15L15 6.49996H18L18 8.49995Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24 12L22.5 10.5L26.5 6L22.5 1.5L24 0L29 5.99995L24 12Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M23 5.49995L1.46229e-05 5.49995L0 3.49995L23 3.49995L23 5.49995Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M23 8.49995H20L20 6.49996H23L23 8.49995Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgRelationGrouped);
export default ForwardRef;
